<template>
  <div class="card-container">
    <div class="block border-round mb-3">
      <div class="flex flex-column card-container green-container shadow-4">
        <img v-if="this.origem == 'FormularioInicial'" id="imagemErro" />
        <img v-if="this.origem == 'PaginaNaoEncontrada'" id="imagem404" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginaErroComponent",
  props: {
    origem: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
#imagemErro,
#imagem404 {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  min-width: 100%;
  min-height: 100%;
  background-size: 100vw 100vh;
}
#imagem404 {
  background-image: url("@/assets/imgs/imagem_404_desktop.png");
}
#imagemErro {
  background-image: url("@/assets/imgs/imagem_conexao_servidor_desktop.png");
}
@media only screen and (max-width: 920px) {
  @media screen and (orientation: portrait) {
    #imagemErro {
      background-image: url("@/assets/imgs/imagem_conexao_servidor_mobile.png");
    }
    #imagem404 {
      background-image: url("@/assets/imgs/imagem_404_mobile.png");
    }
  }
}
</style>